import { WithStyles } from '@material-ui/core';
import styles from './CreditNoteDetails.styles';
import { ILocationState } from 'utils/hooks';

export default interface ICreditNoteDetailsProperties extends WithStyles<typeof styles> {
    values?: any;
    dirty?: boolean;
    resetForm?(): void;
    changeSelectedTab?(moduleName: string, locationObj?: ILocationState): void;
    changeConfirmationDialog?(options: any): void;
}

export interface ICreditNoteDetailsHandle {
    CreditNoteDetailsOk?(): void;
    CreditNoteDetailsCancel?(): void;
    isChangesSavedOrDiscarded(): boolean;
}

export const changeFormFieldNames = ['SiteCode', 'Age', 'Terms'];
